import catalogPreview from './catalog/preview.webp';
import heroFull from './hero/full.webp';
import comparison01SourcePreview from './comparisons/comparison-01/source/preview.webp';
import comparison01SourceFull from './comparisons/comparison-01/source/full.webp';
import comparison01ResultPreview from './comparisons/comparison-01/result/preview.webp';
import comparison01ResultFull from './comparisons/comparison-01/result/full.webp';
import comparison02SourcePreview from './comparisons/comparison-02/source/preview.webp';
import comparison02SourceFull from './comparisons/comparison-02/source/full.webp';
import comparison02ResultPreview from './comparisons/comparison-02/result/preview.webp';
import comparison02ResultFull from './comparisons/comparison-02/result/full.webp';
import comparison03SourcePreview from './comparisons/comparison-03/source/preview.webp';
import comparison03SourceFull from './comparisons/comparison-03/source/full.webp';
import comparison03ResultPreview from './comparisons/comparison-03/result/preview.webp';
import comparison03ResultFull from './comparisons/comparison-03/result/full.webp';
import comparison04SourcePreview from './comparisons/comparison-04/source/preview.webp';
import comparison04SourceFull from './comparisons/comparison-04/source/full.webp';
import comparison04ResultPreview from './comparisons/comparison-04/result/preview.webp';
import comparison04ResultFull from './comparisons/comparison-04/result/full.webp';
import result01Full from './results/result-01/full.webp';
import result02Full from './results/result-02/full.webp';
import result03Full from './results/result-03/full.webp';
import result04Full from './results/result-04/full.webp';
import result05Full from './results/result-05/full.webp';

const image = (preview, full, alt, label) => ({
  preview,
  full,
  alt,
  ...(label ? { label } : {}),
});

export const project02Images = {
  catalog: image(
    catalogPreview,
    catalogPreview,
    '3D BIM-модель промышленного объекта'
  ),
  hero: image(heroFull, heroFull, 'Облако точек промышленного объекта'),
  comparisons: [
    {
      id: 'comparison-01',
      source: image(
        comparison01SourcePreview,
        comparison01SourceFull,
        'Продольный разрез исходного облака точек',
        'Point Cloud'
      ),
      result: image(
        comparison01ResultPreview,
        comparison01ResultFull,
        'Продольный разрез итоговой 3D BIM-модели',
        '3D BIM Model'
      ),
    },
    {
      id: 'comparison-02',
      source: image(
        comparison02SourcePreview,
        comparison02SourceFull,
        'Поперечный разрез исходного облака точек',
        'Point Cloud'
      ),
      result: image(
        comparison02ResultPreview,
        comparison02ResultFull,
        'Поперечный разрез итоговой 3D BIM-модели',
        '3D BIM Model'
      ),
    },
    {
      id: 'comparison-03',
      source: image(
        comparison03SourcePreview,
        comparison03SourceFull,
        'Технологическая зона в исходном облаке точек',
        'Point Cloud'
      ),
      result: image(
        comparison03ResultPreview,
        comparison03ResultFull,
        'Технологическая зона в итоговой 3D BIM-модели',
        '3D BIM Model'
      ),
    },
    {
      id: 'comparison-04',
      source: image(
        comparison04SourcePreview,
        comparison04SourceFull,
        'Оборудование и площадки в исходном облаке точек',
        'Point Cloud'
      ),
      result: image(
        comparison04ResultPreview,
        comparison04ResultFull,
        'Оборудование и площадки в итоговой 3D BIM-модели',
        '3D BIM Model'
      ),
    },
  ],
  results: [
    image(
      result01Full,
      result01Full,
      'Общий внешний вид итоговой 3D BIM-модели'
    ),
    image(
      result02Full,
      result02Full,
      'Внутреннее устройство итоговой 3D BIM-модели'
    ),
    image(
      result03Full,
      result03Full,
      'Архитектура и оборудование итоговой 3D BIM-модели'
    ),
    image(result04Full, result04Full, 'Внешний контур итоговой 3D BIM-модели'),
    image(
      result05Full,
      result05Full,
      'Технологическое оборудование итоговой 3D BIM-модели'
    ),
  ],
};
